import { db } from '../firebase';
import { collection, query, where, getDocs, updateDoc, doc, writeBatch, serverTimestamp, getDoc } from 'firebase/firestore';

export const approveAllPendingCashTips = async (tenantId: string): Promise<number> => {
  const tipsRef = collection(db, 'tenants', tenantId, 'cash_tips');
  const q = query(tipsRef, where('status', '==', 'Pending'));
  const querySnapshot = await getDocs(q);
  
  let approvedCount = 0;
  const updatePromises = querySnapshot.docs.map(async (tipDoc) => {
    await updateDoc(doc(db, 'tenants', tenantId, 'cash_tips', tipDoc.id), {
      status: 'Approved'
    });
    approvedCount++;
  });

  await Promise.all(updatePromises);
  return approvedCount;
};

export const rejectTransaction = async (tenantId: string, collection: string, docId: string, reason: string): Promise<void> => {
  const tipRef = doc(db, 'tenants', tenantId, collection, docId);
  const tipSnap = await getDoc(tipRef);
  
  if (!tipSnap.exists()) {
    throw new Error('Tip document not found');
  }

  const tipData = tipSnap.data();
  // Find the master transaction: usually masterTxId or relatedTransactionId
  const masterTxId = tipData.masterTxId || tipData.relatedTransactionId;
  if (!masterTxId) {
    throw new Error(`Master transaction ID not found for tip ${docId}`);
  }
  const masterRef = doc(db, 'tenants', tenantId, 'master_transactions', masterTxId);
  const masterSnap = await getDoc(masterRef);
  if (!masterSnap.exists()) {
    throw new Error(`Master transaction document not found for ID ${masterTxId}`);
  }

  const batch = writeBatch(db);
  
  // 1. Update tip status
  console.log(`REJECT_DEBUG: Updating tip ${docId} to Rejected`);
  batch.update(tipRef, {
    status: 'Rejected',
    rejectionReason: reason,
    rejectionTimestamp: serverTimestamp()
  });

  // 2. Update master transaction
  console.log(`REJECT_DEBUG: Updating master ${masterTxId} to Rejected`);
  batch.update(masterRef, {
    submissionStatus: 'Rejected',
    allocationStatus: 'Rejected',
    auditContext: 'Rejected: ' + reason
  });

  await batch.commit();
  console.log(`REJECT_DEBUG: Batch committed successfully`);
};

export const getPendingReviewTipsCount = async (tenantId: string): Promise<number> => {
  if (!tenantId) return 0;
  try {
    const cashRef = collection(db, 'tenants', tenantId, 'cash_tips');
    const jarRef = collection(db, 'tenants', tenantId, 'jar_tips');
    const posRef = collection(db, 'tenants', tenantId, 'master_transactions');

    const [cashSnap, jarSnap, posSnap] = await Promise.all([
      getDocs(query(cashRef, where('status', '==', 'Pending'))).catch(() => ({ size: 0 })),
      getDocs(query(jarRef, where('status', '==', 'Pending'))).catch(() => ({ size: 0 })),
      getDocs(query(posRef, where('source', 'in', ['POS', 'POS Override']), where('submissionStatus', '==', 'Pending'))).catch(() => ({ size: 0 })),
    ]);

    return (cashSnap.size || 0) + (jarSnap.size || 0) + (posSnap.size || 0);
  } catch (err) {
    console.error('Error fetching pending review tips count:', err);
    return 0;
  }
};

